import { Theme } from '@mui/material/styles';

export const school = (theme: Theme) => ({
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#F1F1F1',
    padding: '10px 20px',
    borderLeft: '3px solid #4F99E7',
    flexDirection: 'column',
    gap: '20px',

    [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#F1F1F1',
        padding: '10px 20px',
        borderLeft: '3px solid #4F99E7',
        flexDirection: 'row',
        gap: '0px',
    }
}) as const;

export const name = {
    fontWeight: 700,
    display: 'flex',
    fontSize: '16px',
} as const;

export const deleteButton = {
    color: 'removeButton.main',
    fontWeight: 600,
    backgroundColor: 'white.main',
    width: '68px',
    height: '50px',
    border: '1px solid #DC2226',
    borderRadius: '6px',

} as const;

export const errorEW = {
    color: 'error.main',
} as const;

export const error = (theme: Theme) => ({
    marginTop: theme.spacing(2),
    color: 'error.main',
}) as const;

export const text = (theme: Theme) => ({
    marginTop: theme.spacing(2),
}) as const;

export const link = {
    fontWeight: 700,
    color: 'info.main',
} as const;

export const italic = {
    fontStyle: 'italic',
} as const;

export const fieldsSubjectsWrapper = (theme: Theme) => ({
    marginY: theme.spacing(3),
}) as const;

export const fieldsFullRow = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '100%',
} as const;

export const fieldsHalfRow = {
    display: 'flex',
    width: '50%',
} as const;

export const fieldsSubjects = (theme: Theme) => ({
    marginY: theme.spacing(2),
}) as const;

export const fieldSubjects = (theme: Theme) => ({
    marginY: theme.spacing(-3),
}) as const;

export const fieldPublishers = (theme: Theme) => ({
    '& .MuiFormControl-root': {
        flexBasis: '100%',

        [theme.breakpoints.up('md')]: {
            flexBasis: '33%',
        },
    },
}) as const;

export const earlySchoolEducationLevel = (theme: Theme) => ({
    marginTop: theme.spacing(1),
}) as const;

export const subjectTitle = {
    fontWeight: 700,
    marginBottom: '20px',
} as const;

export const functionTitle = {
    fontWeight: 700,
    paddingTop: '20px',
} as const;

export const buttonContainer = {
    display: 'flex',
    gap: '16px',
} as const;

export const changeButton = {
    backgroundColor: '#FFFFFF',
    width: '150px',
    height: '50px',
    border: '1px solid #4F99E7',
    borderRadius: '6px',
    color: '#4F99E7',

    '&:hover': {
        backgroundColor: '#FFFFFF',
    }
} as const;
export const selectField = (theme: Theme) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),

    '& .MuiInputLabel-root': {
        display:'flex',
        flexDirection: 'row-reverse',
        whiteSpace: 'nowrap',

        '&.Mui-focused': {
            color: 'text.secondary',
        },

        '&.Mui-error': {
            color: 'text.secondary',
        },

        '& .MuiFormLabel-asterisk': {
            '&.Mui-focused': {
                color: 'text.secondary',
            },

            '&.Mui-error': {
                color: 'text.secondary',
            },
        },
    },

    '& .MuiInputBase-root': {
        '&.Mui-disabled': {
            '& fieldset': {
                borderColor: 'darkGray.main',
            },

            '&:hover fieldset': {
                borderColor: 'darkGray.dark',
            },
        },

        '& fieldset': {
            borderColor: 'darkGray.main',
            borderWidth: '1px',
            borderRadius: 0,
        },

        '&:hover fieldset': {
            borderColor: 'darkGray.dark',
        },

        '&.Mui-focused fieldset': {
            borderWidth: '1px',
            borderColor: 'darkGray.dark',
        },

        '&.Mui-error fieldset': {
            borderColor: 'darkGray.dark',
        },

        '& .MuiInputBase-input': {
            color: 'text.secondary',
            paddingTop: theme.spacing(1.375),
            paddingBottom: theme.spacing(1.5),
            fontSize: 12,
        }
    },
}) as const;
